import VideoList from '../../components/videos/videoList';
import './index.scss';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GLOBAL_CONSTANTS } from '../../utils/appConstant';
import SampleFAQ from '../../../src/assets/pdfs/FAQs.pdf';
import introToAgripix from '../../../src/assets/pdfs/IntroToAgriPix.pdf';
import promtGuide from '../../../src/assets/pdfs/promptGuide.pdf';

export const TutorialVideos: React.FC = () => {
  const navigate = useNavigate();
  const handleBackNavigation = () => {
    navigate(-1);
  };
  const quickReadLinks = [
    {
      label: GLOBAL_CONSTANTS.INTRO_TO_TOOL,
      href: introToAgripix,
    },
    {
      label: GLOBAL_CONSTANTS.EFFECTIVE_PROMPTING_GUIDE,
      href: promtGuide,
    },
    {
      label: GLOBAL_CONSTANTS.FAQS,
      href: SampleFAQ,
    },
    {
      label: GLOBAL_CONSTANTS.GLOBAL_MARCOM_LIBRARY,
      href: 'https://upllimited.sharepoint.com/sites/GlobalMarcomLibrary',
    },
    {
      label: GLOBAL_CONSTANTS.BRAND_GUIDELINES,
      href: 'https://upllimited.sharepoint.com/sites/GlobalMarcomLibrary/UPL%20Corp/Forms/AllItems.aspx?id=%2Fsites%2FGlobalMarcomLibrary%2FUPL%20Corp%2FBrand%20Management%2FBrand%20Guidelines%2FUPL%20Brand%20Guidelines%2Epdf&parent=%2Fsites%2FGlobalMarcomLibrary%2FUPL%20Corp%2FBrand%20Management%2FBrand%20Guidelines',
    },
    {
      label: GLOBAL_CONSTANTS.LOGOS,
      href: 'https://upllimited.sharepoint.com/sites/GlobalMarcomLibrary/UPL%20Corp/Forms/AllItems.aspx?csf=1&web=1&e=7DA8bh&CID=fb287f27%2D0050%2D4edb%2Dbf24%2D8a54fcae5622&FolderCTID=0x01200014DC90DC19180342AA8E0B22E592C04E&id=%2Fsites%2FGlobalMarcomLibrary%2FUPL%20Corp%2FBrand%20Management%2FLogos%2FUPL%20Preferred%20Logo',
    },
  ];
  return (
    <>
      <div className="quick-reads-container">
        <div className="quick-header">
          <div className="quick-sub-header">
            <button
              className="back-button"
              onClick={handleBackNavigation}>
              <ArrowBackIcon />
              {GLOBAL_CONSTANTS.BACK}
            </button>
            <h2 className="quick-reads-title">
              {GLOBAL_CONSTANTS.QUICK_READS}
            </h2>
          </div>
          <div className="quick-reads-buttons">
            {quickReadLinks.map(
              ({ label, href }, index) => (
                <a
                  key={index}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer">
                  <button className="quick-reads-button">
                    <span>{label}</span>
                    <ArrowOutwardIcon />
                  </button>
                </a>
              )
            )}
          </div>
        </div>
        <h3 className="tutorial-title">
          {GLOBAL_CONSTANTS.TUTORIAL_VIDEOS}
        </h3>
        <VideoList />
      </div>
    </>
  );
};
